import clsx from 'clsx';

export interface MobileBottomNavItemProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

export default function MobileBottomNavItem({
  active,
  label,
  onClick,
}: MobileBottomNavItemProps) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'relative opacity-80 hover:opacity-100 transition',
        active && 'opacity-100'
      )}
    >
      {label}
    </button>
  );
}
